import { t } from 'ttag'
import * as recharts from 'recharts'

import { Link } from '@h2/common/components/link'
import { Text } from '@h2/components/typography/text'

import { Grid } from '../../../../components/containers/grid'

const IndustriesComprising = ({ occupation }) => {
  const { Cell, Pie, PieChart, ResponsiveContainer } = recharts
  const industryDataGraph = occupation?.industries
    ?.map(i => {
      return {
        name: i.name,
        naics: i.naics,
        value: i.percentOfWorkforce
      }
    })
    .sort((industryA, industryB) => industryB.value - industryA.value)
  const baseEmployment =
    (occupation?.outlook?.baseEmployment &&
      occupation.outlook.baseEmployment.toLocaleString()) ||
    'n/a'

  if (!occupation || !industryDataGraph) {
    return null
  }

  const columns = [
    {
      id: 'name',
      sortable: false,
      width: '75%',
      label: t`Industry`,
      render({ naics, name }) {
        return naics ? <Link href={`/industry/detail/${naics}`}>{name}</Link> : name
      }
    },
    {
      id: 'value',
      sortable: false,
      label: t`Percentage`,
      render({ value }) {
        return `${value.toFixed(2)}%`
      }
    }
  ]

  return (
    <>
      <Text>{t`The ${baseEmployment} people currently employed as a ${occupation.title} are typically employed across the following industries:`}</Text>
      <ResponsiveContainer aspect={3 / 2} width="100%">
        <PieChart width={300} height={200} isAnimationActive={false}>
          <Pie data={industryDataGraph} dataKey="value">
            {industryDataGraph?.map((element, index) => (
              <Cell
                key={`cell${index}`}
                fill={dynamicValues.plotColors[index % dynamicValues.plotColors.length]}
              />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      {industryDataGraph.length === 0 ? null : (
        <Grid
          defaultSortBy="name"
          columns={columns}
          data={industryDataGraph}
          options={{ disableFilters: true, fullWidth: true }}
          rowIdKey="naics"
          isPagerVisible={false}
          isRowSelectable={false}
        />
      )}
    </>
  )
}

export { IndustriesComprising }
